import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import { preloadMainPages } from './router/config';
import App from './App.tsx'

// ⭐ 앱 시작 시 주요 페이지 미리 로드
preloadMainPages();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
